import {ErrorMessage} from "@hooks/validate/types";

export function getErrorMessage(errorMessage: ErrorMessage, errorCode?: string,): string {
    if (typeof errorMessage === 'string') {
        return errorMessage;
    }

    if (typeof errorMessage === 'object' && !Array.isArray(errorMessage) && errorMessage && errorCode in errorMessage && typeof errorMessage[errorCode] === 'string') {
        return errorMessage[errorCode] as string
    }
    return ''

}

export function getError(errorMessage: ErrorMessage, error: boolean, errorCode?: string): boolean {
    if (!error) {
        return false
    }
    if (typeof errorMessage === 'string' && error) {
        return true;
    }

    return typeof errorMessage === 'object' && !Array.isArray(errorMessage) && errorCode in errorMessage && typeof errorMessage[errorCode] === 'string';

}

export function getErrorPropsTextField(errorMessage: ErrorMessage, error: boolean, errorCode?: string,): {
    error: boolean,
    helperText: string
} {
    const currentError = getError(errorMessage, error, errorCode)
    const helperText = getErrorMessage(errorMessage, errorCode,)

    if (!currentError) {
        return {
            error: false,
            helperText: ''
        }
    }
    return {
        error: true,
        helperText
    }
}

export function getErrorProps({errorMessage, error, key}: {
    errorMessage: ErrorMessage,
    error: boolean,
    key?: string,
}): {
    error: boolean,
    errorMessage: string
} {
    const currentError = getError(errorMessage, error, key)
    const currentErrorMessage = getErrorMessage(errorMessage, key,)

    if (!currentError) {
        return {
            error: false,
            errorMessage: ''
        }
    }
    return {
        error: true,
        errorMessage: currentErrorMessage
    }
}

export const getErrorFieldFromArray = ({error, errorMessage, key = null, index}: {
    error?: boolean,
    errorMessage: ErrorMessage,
    key?: string | null,
    index: number
}): boolean => {
    if (!key) {
        return !!(error && errorMessage && Array.isArray(errorMessage) && errorMessage[index]);

    }
    //@ts-ignore
    if (error && errorMessage && errorMessage.hasOwnProperty(index) && errorMessage[index].hasOwnProperty(key)) {
        return true
    }
}

export const getErrorMessageFieldFromArray = ({error, errorMessage, key = null, index}: {
    error?: boolean,
    errorMessage: ErrorMessage,
    key?: string | null,
    index: number
}): string | undefined => {
    if (!key) {
        //@ts-ignore
        if (error && errorMessage  && errorMessage.hasOwnProperty(index)  && typeof errorMessage[index] === 'string') {
            //@ts-ignore
            return errorMessage[index] as string
        }
        return
    }
    //@ts-ignore
    if (error && errorMessage && errorMessage.hasOwnProperty(index)  && typeof errorMessage[index] === 'object' && errorMessage[index].hasOwnProperty(key)) {
        //@ts-ignore
        return errorMessage[index][key] as string
    }
}

export function getErrorPropsFromArray({errorMessage, error, key, index}: {
    errorMessage: ErrorMessage,
    error: boolean,
    key?: string,
    index: number
}): {
    error: boolean,
    errorMessage: string
} {
    const currentError = getErrorFieldFromArray({error, errorMessage, key, index})

    if (!currentError) {
        return {
            error: false,
            errorMessage: ''
        }
    }

    const currentErrorMessage = getErrorMessageFieldFromArray({error, errorMessage, key, index})

    return {
        error: true,
        errorMessage: currentErrorMessage
    }
}
